import { createApi } from '@reduxjs/toolkit/query/react';
 import { VITE_API_V2_URL } from "codes";
import type { AuditTrail } from "./api-audittrail.d";
 import { axiosBaseQuery } from "helpers/axiosbaseQuery";
 
 export const audittrail = createApi({
   reducerPath: "auditTrail",
   tagTypes: ["AUDIT_TRAIL"],
   baseQuery: axiosBaseQuery({
     baseUrl: `${VITE_API_V2_URL}`,
   }),
   endpoints: (builder) => ({
     fetchAuditTrails: builder.query<AuditTrail[], string>({
       query: (recordId) => ({
         url: `/audit/logs_by_id/${recordId}`,
         method: "get",
       }),
       transformResponse: (response: { data: AuditTrail[] }) => response.data,
       providesTags: ["AUDIT_TRAIL"],
     }),
   }),
 });
 
 export const { useFetchAuditTrailsQuery } = audittrail;
